import { ChartBinSize, ChartDefinition, ChartGroupByMode, ChartKey, ChartQueryParam, ChartRendererType } from '@frontend/chart/types';

import { EQUIPMENT_TIMERS_DURATION_CHART_ENDPOINT } from '../equipment-chart-endpoints';

export const EQUIPMENT_TIMERS_DURATION_BY_PRODUCT_LIST_CHART_DEFINITION: ChartDefinition = {
    key: ChartKey.EQUIPMENT_TIMERS_DURATION_BY_PRODUCT_LIST,
    chartType: ChartRendererType.LIST,
    endpoint: EQUIPMENT_TIMERS_DURATION_CHART_ENDPOINT,
    filters: [{ key: ChartQueryParam.BIN_SIZE, value: ChartBinSize.FULL_PERIOD }],
    groupBy: ChartQueryParam.PRODUCT_ID,
    groupByMode: ChartGroupByMode.VALUE
};
